import { useAxios } from "./useAxios"
import { Pagination } from "@/interfaces/Pagination"
import { useBot } from "./useBot"
import { LeadStartParameter } from "@/interfaces/leads/LeadStartParam"

const axios = useAxios()

export interface GetAllLeadStartParamsParams {
  page?: string
  perPage?: string
}

export function useLeadStartParameters() {
  const { selectedBot } = useBot()

  const getAll = async (params?: GetAllLeadStartParamsParams): Promise<Pagination<LeadStartParameter>> => {
    if (params) {
      params = Object.fromEntries(
        Object.entries(params).filter(([param, value]) => !!value)
      )
    }

    const response = await axios.get(`/bots/${selectedBot.value?.id}/lead-start-parameters`, { params })

    return response.data
  }

  return {
    getAll,
  }
}